import axios from "./axios"

function search(query) {
    return axios().get("/item-groups-search", {
        params: {
            search: query,
            relations: ["parent"]
        }
    })
}

function create(data) {
    return axios().post("/item-groups", data, {
        headers: {
            "X-Request-ID": data.idempotentKey
        }
    })
}

function findByID(id){
    return axios().get(`/item-groups/${id}`, {
        params: {
            relations: ["parent"]
        }
    });
}

function remove(data){
    return axios().delete(`/item-groups/${data.id}`);
} 
function update(data){
    return axios().put(`/item-groups/${data.id}`, data);
} 

function index(params) {
    params.limit = params.itemsPerPage;
    params.offset = (params.page - 1) * params.limit;
    return axios().get("/item-groups", {
        params
    })
}

export default {
    search,
    create,
    findByID,
    remove,
    update,
    index
}